import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse, Reimbursement } from '../types';

const URL = '/v2/reimbursement-transactions';

class ReimbursementTransactionService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<Reimbursement>> {
    return axios.get(URL, config);
  }
}

export { ReimbursementTransactionService };
